$( document ).ready( function() {
	'use strict';

	/**
	 * Trigger AJAX loading of the last WP_Post items.
	 */
	$( '.js-view-more-link' ).on( 'click', function( event ) {
		event.preventDefault();

		var $loadMoreContainer = $( this ).closest( '.idnagroup-news-view-more' );

		idnagroupNewsBlockLoadMore(
			{
				'category': $loadMoreContainer.attr( 'data-category' ),
				'exclude': $loadMoreContainer.attr( 'data-exclude' ),
				'postType': $loadMoreContainer.attr( 'data-post-type' ),
				'template': $loadMoreContainer.attr( 'data-template' ),
			},
			$loadMoreContainer.closest( '[data-load-more-container]' )
		);
	} );

	/**
	 * Load and append the last items for a News Block element.
	 *
	 * @param data
	 * @param $container
	 */
	function idnagroupNewsBlockLoadMore( data, $container ) {
		$.ajax( {
			url: '/wp-json/idnagroup-news/v1/posts/rendered/',
			type: 'POST',
			data: data,
			beforeSend: function() {
				$( '.js-view-more-link', $container ).toggle();
				$( '.js-view-more-loading', $container ).toggle();
			},
			success: function( data ) {
				$( '.idnagroup-news-view-more', $container ).remove();
				$( '[data-load-more-content-area]', $container ).append( $( data ) );
			},
		} );
	}

} );



// WEBPACK FOOTER //
// ./IdnagroupNews/js/loadmore.js